export default {
  row1:[
  {
    column: "column1",
    columnWidth: "50%",
    rows: {
      row1: [
        {
          name: "importUDFGoJobNo",
          label: "@GO Job No",
          component: "text-field",
          width: "100%",
        },
        
      ],
      row2: [
        {
          name: "importUDFGoDate",
          label: "@GO DATE",
          component: "dateselector",
          width:"100%"
          
        },
      
      ],
      row3: [
        {
          name: "importUDFRemarks",
          label: "Remarks",
          component: "text-field",
          height : 90,
          
        },
       
      ],
      row4: [
        {
          name: "importUDFBillNo",
          label: "Bill No",
          component: "text-field",
         
        },
      
      ],
      row5: [
        {
          name: "importUDFBillDate",
          label:"UDF Bill Date",
          component: "dateselector",
          width:"100%"
         
        },
      ],
      row6: [
        {
          name: "importUDFCanNo",
          label: "CAN NO",
          component: "text-field",
         
        },
       
      ],
      row7: [
        {
          name: "importUDFCanDate",
          label: "CAN DATE",
          component: "dateselector",
          width:"100%"          
        },
      ],
   
      row8: [
        {
          name: "importUDFPoNo",
          label: "PO No",
          component: "text-field",
          
        },
      ],
      
    },
  },
]
};
